
import firebase from 'firebase/app'
import 'firebase/firestore'

let config = {
  apiKey: 'AIzaSyDmWxRFYzar5zX6dk9YIsFxbilrm4cTmPM',
  authDomain: 'jacksons-earth-moving.firebaseapp.com',
  databaseURL: 'https://jacksons-earth-moving.firebaseio.com',
  projectId: 'jacksons-earth-moving',
  storageBucket: 'jacksons-earth-moving.appspot.com',
  messagingSenderId: '261048693559'
}

const firebaseApp = firebase.initializeApp(config)
const firestore = firebaseApp.firestore()

firebaseApp.firestore()
  .enablePersistence()
  .then(resp => {
    console.log('persistance enabled')
  })
  .catch(err => {
    console.log('enablePersistence ERROR:', err.toString())
    if (err.code === 'failed-precondition') {
      console.log('failed-precondition')
    } else if (err.code === 'unimplemented') {
      console.log('unimplemented')
    }
  })

export default firestore
